import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

/**
 * Brand loading indicator: the J9 logo whose two hearts repeatedly fill with
 * orange like a rising waterline. Replaces the old CSS rotating ring.
 *
 *   <bv-logo-loader></bv-logo-loader>
 *   <bv-logo-loader [size]="128"></bv-logo-loader>
 *
 * The fill is a single full-width orange rect, clipped to the union of both
 * heart shapes (expressed in the root viewBox space so the rotated "J" heart
 * still fills straight up), animated upward through the union's y-range.
 */
@Component({
    selector: "bv-logo-loader",
    templateUrl: "./logo-loader.component.html",
    styleUrls: ["./logo-loader.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: "bv-logo-loader",
        role: "progressbar",
        "aria-label": "Loading",
        "[style.width.px]": "size",
        "[style.height.px]": "size",
    },
})
export class BvLogoLoaderComponent {
  /** Rendered width/height in px (the logo is square). */
  @Input() size = 48;
}
